import React, { useState } from "react";
import { FullScreenDialog } from "./FullScreenDialog";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { SmartTextField } from "./SmartTextField";

/**
 * @param {object} props
 * @param {React.ReactNode} props.helperText
 * @param {string} props.title
 * @param {string|number|undefined} props.initialValue
 * @param {boolean} [props.multiline]
 * @param {boolean} props.isBusy
 * @param {boolean} props.onEnterDisabled
 * @param {import("react").ReactNode} props.children
 * @param {(text: (string|number|undefined)) => Promise<void>} props.onSave
 * @param {() => void} [props.onDelete]
 */
export const EditTextFieldDialog = ({
  helperText,
  onSave,
  title,
  isBusy,
  children,
  initialValue,
  multiline,
  onEnterDisabled = false,
  onDelete,
}) => {
  const [updateText, setUpdateText] = useState(initialValue);

  const onSaveHandler = () => {
    onSave(updateText);
  };

  /**
   * @param {string} text
   */
  const saveAndClose = (text) => {
    setUpdateText(text);
    onSave(text);
  };

  return (
    <FullScreenDialog
      title={`Edit ${title.toLowerCase()}`}
      actionText="SAVE"
      onSaveHandler={onSaveHandler}
      isBusy={isBusy}
      CustomControl={children}
      onDeleteHandler={onDelete}
    >
      <Card elevation={2}>
        <Box p={1}>
          <SmartTextField
            initialValue={initialValue}
            onChange={setUpdateText}
            onEnter={saveAndClose}
            onEnterDisabled={onEnterDisabled}
            autoFocus
            label={title}
            helperText2={helperText}
            multiline={multiline}
          />
        </Box>
      </Card>
    </FullScreenDialog>
  );
};
